<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props:{
    Labels:Array,
    DataSet:Array
  },
  mounted() {
    this.renderChart(
      {
        labels:this.Labels,
        datasets: this.DataSet
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
            },
          ],
        },
      }
    );
  },
};
//  [
//           "ม.ค.",
//           "ก.พ.",
//           "มี.ค.",
//           "เม.ย.",
//           "พ.ค.",
//           "มิ.ย.",
//           "ก.ค.",
//           "ส.ค.",
//           "ก.ย.",
//           "ต.ค.",
//           "พ.ย.",
//           "ธ.ค​.",
//         ]
// [
// [
//           {
//             label: "รายได้",
//             backgroundColor: "#1E88E5",
//             data: [
//               375754,
//               510656,
//               615770,
//               619586,
//               649480,
//               674194,
//               765043,
//               765188,
//               771255,
//               831973,
//               897030,
//               949852,
//             ],
//           },
//           {
//             label: "ค้างจ่าย",
//             backgroundColor: "#BBDEFB",
//             data: [
//               132023,
//               174039,
//               195907,
//               197591,
//               385985,
//               396869,
//               462361,
//               497564,
//               518072,
//               588393,
//               828838,
//               865028,
//             ],
//           },
//         ]
</script>


